// utils/request.js

// 基础配置
const IS_H5 = !!import.meta.env.VITE_APP_BASE;
const FM_URL = import.meta.env.VITE_API_FM_API;
const KEAPP_URL = import.meta.env.VITE_API_KEAPP_API;
const EASYSHIP_URL = import.meta.env.VITE_API_EASYSHIP_API;

const FM_APP_ID = import.meta.env.VITE_PUBLIC_APP_ID_FM_API;
const FM_APP_KEY = import.meta.env.VITE_PUBLIC_APP_KEY_FM_API;
// const TIMEOUT = 60 * 1000 // 请求超时时间

const systemInfo = uni.getSystemInfoSync();
const platform = systemInfo.platform;


/**
 * 基于uni.request的请求封装
 * @param {Object} options 请求配置
 * @returns {Promise} 返回Promise对象
 */
const request = (options) => {
	// 请求拦截
	return new Promise((resolve, reject) => {
		// 显示加载中
		const hideLoading = options.hideLoading
		if (!hideLoading) {
			uni.showLoading({
				title: "Loading...",
				mask: true,
			});
		}

		// 合并请求头
		const header = {
			"Content-Type": "application/json",
			os: platform,
			version: '1.0.0',
			...options.header,
		};

		const token = uni.getStorageSync("token");
		if (token) {
			header["Authorization"] = `Bearer ${token}`;
		}
		
		const thirdt = uni.getStorageSync("thirdt");
		if (!token && thirdt) {
			try {
				header["token"] = atob(thirdt);
			}catch(err){}
		}

		// 发起请求
		uni.request({
			url: options.url,
			method: options.method || "GET",
			data: options.data || {},
			header,
			success: (res) => {
				// 响应拦截
				if (!hideLoading) uni.hideLoading();
				if (res.statusCode === 200) {
					if(res.data?.errors?.[0]?.code === 1007) {
						handleHttpError(401, res);
						return
					}
					resolve(res.data);
				} else {
					// HTTP错误处理
					console.log(res)
					handleHttpError(res.statusCode, res);
					reject(res);
				}
			},
			fail: (err) => {
				// 网络错误处理
				if (!hideLoading) uni.hideLoading();
				handleNetworkError(err);
				reject(err);
			},
			// complete: () => {
			//   uni.hideLoading()
			// }
		});
	});
};

const requestf = (options, version = "v4") => {
	options.url = `${FM_URL}/${version}` + options.url;
	return request(options);
};

const requestfkey = (options, version = "v4") => {
	options.url = `${FM_URL}/${version}` + options.url;
	return request({
		...options,
		header: {
			appId: FM_APP_ID,
			appKey: FM_APP_KEY,
		}
	});
};

const requestk = (options, version = "v6") => {
	options.url = `${KEAPP_URL}/api/${version}` + options.url;
	return request(options);
};


const requeste = (options) => {
	options.url = `${EASYSHIP_URL}/api` + options.url;
	return request(options);
};

/**
 * 处理业务错误
 */
// function handleBusinessError(error) {
//   const errorMap = {
//     401: "未授权，请重新登录",
//     403: "拒绝访问",
//     404: "请求资源不存在",
//     500: "服务器错误",
//   };

//   const message =
//     error.msg || error.message || errorMap[error.code] || "未知错误";

//   uni.showToast({
//     title: message,
//     icon: "none",
//     duration: 2000,
//   });
// }

/**
 * 处理HTTP错误
 */
function handleHttpError(statusCode, res) {
	if (statusCode === 401 || statusCode === 403) {
		uni.removeStorageSync('token');
		uni.removeStorageSync('mobile');
		const url = IS_H5 ? "/pages/mobileLogin/index" : "/pages/login/index";
		uni.reLaunch({
			url,
		});
	}
}

/**
 * 处理网络错误
 */
function handleNetworkError(error) {
	if (error.errMsg && error.errMsg.indexOf("timeout") !== -1) {
		uni.showToast({
			title: "Request timeout, please check the network",
			icon: "none",
		});
	} else {
		uni.showToast({
			title: "Network connection unavailable",
			icon: "none",
		});
	}
}

export {
	requestf,
	requestk,
	requeste,
	requestfkey
};

export default request;